import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const KEY = "active_cookie_consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setVisible(true), 1400);
      return () => clearTimeout(t);
    }
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 24, scale: 0.98 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 24, scale: 0.98 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 sm:right-auto sm:max-w-md z-[60]"
          data-testid="cookie-banner"
          role="dialog"
          aria-label="Cookie consent"
        >
          <div className="rounded-2xl border border-slate-200 bg-white/90 backdrop-blur-xl p-6 shadow-[0_8px_40px_rgba(15,23,42,0.08)]">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-400">Privacy</p>
            <p className="mt-2.5 text-sm text-slate-600 leading-relaxed">
              We use only essential cookies and a consent choice record. No advertising trackers are loaded. Details in our{" "}
              <Link to="/privacy" data-testid="cookie-privacy-link" className="text-slate-950 font-medium underline underline-offset-2 hover:text-signal transition-colors">
                Privacy & Cookie Policy
              </Link>.
            </p>
            <div className="mt-5 flex gap-3">
              <button
                data-testid="cookie-accept-btn"
                onClick={() => choose("accepted")}
                className="flex-1 rounded-full bg-obsidian text-white text-[13px] font-medium px-5 py-2.5 hover:bg-signal transition-colors duration-300"
              >
                Accept
              </button>
              <button
                data-testid="cookie-decline-btn"
                onClick={() => choose("declined")}
                className="flex-1 rounded-full border border-slate-300 text-slate-700 text-[13px] font-medium px-5 py-2.5 hover:border-slate-950 transition-colors duration-300"
              >
                Decline
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
